module.exports = __webpack_public_path__ + "img/AMWETCarousel_hand.9424e268.webp";